//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import IconView from "@/components/objects/IconView.vue";
import { STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import get from 'lodash/get.js'

export default {
  name: "CarouselFuturesCategories",
  components: { IconView },
  props: {
    items: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    hideCategories: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      navTreeItems: [],
      navItems: [],
      currentCategory: "",
      swiper: null,
      initObserver: null,
      imagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
      colors: [
        '#FB8B24',
        '#41B06E',
        '#7C73C0',
        '#D04848',
        '#7A4495',
        '#CD5888',
        '#325288',
        '#59C1BD'
      ],
    }
  },
  computed: {
    navTreeDetail() {
      var categories = null

      var respCat = this.$store.state.art.materialCategories

      if(respCat){
        categories = []

        var indexCat = null;
        var category = null;

        for(indexCat in respCat){
          category = respCat[indexCat]

          // if(category.url != "events") {
          // }
          categories.push(category)

          if(categories.length >= 7){
            break;
          }
        }
      }

      return categories
    },
    mainArts() {
      return this.$store.getters['art/getMainArts'];
    },
    isStaticMode() {
      return Array.isArray(this.items)
    },
    displayItems() {
      return this.isStaticMode ? this.items : this.navItems
    },
    displayTitle() {
      if (this.title) return this.title
      return this.currentCategory?.label || ''
    },
  },
  watch: {
    displayItems() {
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.update()
          this.swiper.updateAutoHeight(0)
        }
      })
    },
    navTreeDetail(newVal) {
      if (this.isStaticMode) return
      this.navTreeItems = newVal;
    },
    currentCategory(category) {
      if (this.isStaticMode) return
      // var excludIds = this.mainArts.map(art => art.id);

      var params = {
        limit: 7,
        offset: 0,
        category_id: category.id,
        // exclude: excludIds.filter(x => x).join(','),
        order: '-total_score'
      }

      this.$store.dispatch('art/publicObjects', params).then(response => {
        this.navItems = response.items
        this.isLoading = false
      })
    }
  },
  mounted(){
    if (this.isStaticMode) {
      this.initSwiper()
      return
    }

    this.navTreeItems = this.navTreeDetail;

    if(this.navTreeItems) {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.client) {
        this.observeInit()

      }
    }

  },
  beforeDestroy() {
    if (this.initObserver) {
      this.initObserver.disconnect()
      this.initObserver = null
    }
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  },
  methods:{
    observeInit() {
      if (this.swiper) {
        return
      }
      if (!('IntersectionObserver' in window) || !this.$el) {
        this.initSwiper()
        return
      }

      this.initObserver = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) {
          return
        }
        this.initObserver.disconnect()
        this.initObserver = null
        this.initSwiper()
      }, {
        rootMargin: '300px 0px',
      })

      this.initObserver.observe(this.$el)
    },
    initSwiper() {
      const swiperEl = this.$refs.artsSwiperContainer
      if (!swiperEl || this.swiper) {
        return
      }

      const initSwiper = () => {
        if (!this.isStaticMode && this.navTreeItems?.length) {
          this.selectCategory(this.navTreeItems[0])
        }
        return this.$nextTick()
      }

      import('@/plugins/swiper.js')
        .then(({ Swiper, Navigation }) => {
          this.swiper = new Swiper(swiperEl, {
            autoHeight: true,
            preventClicks: true,
            preventClicksPropagation: true,
            touchStartPreventDefault: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            init: true,
            navigation: {
              nextEl: this.$refs.nextButton,
              prevEl: this.$refs.prevButton,
            },
            modules: [Navigation],
            observer: true,
            observeParents: true,
            on: {
              init: async function (swiper) {
                await initSwiper()
                swiper.updateAutoHeight(0)
              },
            },
            breakpoints: {
              640: {
                spaceBetween: 20,
              },
              960: {
                spaceBetween: 30,
              }
            }
          })
        })
    },
    goToUser(userId) {
      if (!userId) return
      this.$router.push({ name: 'u-id', params: { id: userId } });
    },
    getAuthor(item) {
      return item?.user || {}
    },
    getAuthorId(item) {
      return this.getAuthor(item).id
    },
    getAuthorName(item) {
      const user = this.getAuthor(item)
      return user.profile?.nickname || user.username || ''
    },
    getAuthorIcon(item) {
      return this.getAuthor(item).profile?.icon || null
    },
    articleRouteName(article) {
      return article.is_spec_project ? 'sp-slug' : 'art-slug'
    },
    getColor(index) {
      return this.colors[index % this.colors.length];
    },
    selectCategory(category) {
      if (this.currentCategory && this.currentCategory.id !== category.id) {
        this.isLoading = false;
      }

      if (this.currentCategory.id !== category.id){
        this.isLoading = true
        this.currentCategory = category
      }

      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.update()
          this.swiper.slideTo(0)
        }
      });
    },
    resolvedImagePath(item){
      const id = this.resolvedImageId(item)
      if (!id) {
        const iconPath = this.resolvedIconPath(item)
        return iconPath ? this.$addServerPath(iconPath) : require(`~/assets/img/new-logo-full.png`)
      }
      if (/^https?:\/\//.test(id)) {
        return id
      }
      return this.imagePath[0].replace('$id', id)
    },
    resolvedImageId(item) {
      const imageBlock = (item.blocks || []).find(block => block?.type === 'image' && block.image)
      return get(item, this.imagePath[1])
        || item.image_450_file
        || item.image_file
        || imageBlock?.image?.image_450_file
        || imageBlock?.image?.image_file
        || imageBlock?.image?.image_url
    },
    resolvedIconPath(item) {
      const imageBlock = (item.blocks || []).find(block => block?.type === 'image' && block.icon)
      const icon = item.icon
        || item.event_icon
        || imageBlock?.icon
        || get(item, 'type.icon')
        || get(item, 'category.icon')
        || get(item, 'category_annotated.icon')
        || get(item, 'categories_annotated.0.icon')

      return icon ? `/admin/icon_files/${icon}/picto_white/` : ''
    },
    getStyle(item){
      const imageUrl = this.resolvedImagePath(item);
      return {
        backgroundImage: `url(${imageUrl})`,
      };
    },
    reducedText(text) {
      const textArray = text.split(' ')
      let firstLine = ''
      let secondLine = ''
      let thirdLine = ''

      for (let word of textArray) {
        if (firstLine.length + word.length < 18 && !secondLine.length) {
          firstLine = firstLine + ' ' + word
        } else if (secondLine.length + word.length < 23 && !thirdLine.length) {
          secondLine = secondLine + ' ' + word
        } else {
          thirdLine = thirdLine + ' ' + word
        }
      }

      return `${firstLine}<br />${secondLine}<br />${thirdLine}`
    }
  }
}
